import React from "react";
import Header from "@/components/Header";
import LegalFooter from "@/components/LegalFooter";

/** Minimalist page shell used by /contatti, /network, /come-funziona to keep a
 *  consistent look with the redesigned landing. */
export default function PageShell({ eyebrow, title, intro, children, testid }) {
  return (
    <div className="min-h-screen bg-[#F5F0E6] text-[#1A1610] flex flex-col overflow-x-hidden" data-testid={testid}>
      <Header showNav />
      <main className="flex-1">
        <section className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 pt-16 pb-6 sm:pt-24">
          {eyebrow && (
            <p className="text-xs sm:text-sm tracking-[0.4em] uppercase text-[#B8965A] mb-6" data-testid="page-eyebrow">
              {eyebrow}
            </p>
          )}
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.1] max-w-4xl text-[#1A1610]"
            style={{ fontFamily: "Cormorant Garamond, serif" }}
            data-testid="page-title"
          >
            {title}
          </h1>
          <div className="mt-8 h-px w-24 bg-[#B8965A]" aria-hidden="true" />
          {intro && (
            <p className="mt-8 max-w-3xl text-[#4A3F30] text-base sm:text-lg leading-relaxed" data-testid="page-intro">
              {intro}
            </p>
          )}
        </section>
        <section className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 py-12 sm:py-16">
          {children}
        </section>
      </main>
      <LegalFooter />
    </div>
  );
}
